import { useState, useEffect } from "react";

const CONSENT_KEY = "cookie_consent_v1";

export function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(CONSENT_KEY)) {
      setVisible(true);
    }
  }, []);

  function handleAccept() {
    localStorage.setItem(CONSENT_KEY, "accepted");
    setVisible(false);
  }

  function handleDecline() {
    localStorage.setItem(CONSENT_KEY, "essential_only");
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div className="cookie-consent" role="dialog" aria-label="Cookie consent">
      <p className="cookie-consent__text">
        We use essential cookies to keep you signed in and optional cookies to
        improve your experience. See our <a href="/privacy">Privacy Policy</a>.
      </p>
      <div className="cookie-consent__actions">
        <button
          type="button"
          className="btn btn--primary btn--sm"
          onClick={handleAccept}
        >
          Accept all
        </button>
        <button
          type="button"
          className="btn btn--secondary btn--sm"
          onClick={handleDecline}
        >
          Essential only
        </button>
      </div>
    </div>
  );
}
